import './PortalSectionLayout.css';
import './PortalSectionInteractions.css';
import './ContactPage.css';

export function ContactPage() {
  return (
    <main className="portal-section-page portal-section-page--contact portal-page-surface text-slate-900" aria-labelledby="contact-title">
      <div className="portal-page-content">
        <header className="portal-page-heading mb-10">
          <h1 id="contact-title" className="text-3xl font-semibold text-slate-900">Kontakt</h1>
        </header>

        <div className="portal-contact__intro">
          <section className="portal-contact__details" aria-labelledby="contact-practice">
            <h2 id="contact-practice">Zahnarztpraxis Müller und Weidmann</h2>
            <address>
              Moserstrasse 27<br />
              8200 Schaffhausen
            </address>
            <p className="portal-contact__group">
              <a href="tel:+41526254625">T +41 52 625 46 25</a><br />
              <a href="mailto:info@mueller-weidmann.ch">info@mueller-weidmann.ch</a>
            </p>
            <p className="portal-contact__group">
              Montag bis Freitag<br />
              08.00 bis 12.00 Uhr<br />
              13.00 bis 17.00 Uhr
            </p>
          </section>
          <figure className="portal-contact__photo">
            <img src={`${process.env.PUBLIC_URL}/images/praxisgebaeude.jpg`}
              alt="Praxisgebäude von RiviDent in Schaffhausen" width={2752} height={1536} decoding="async" />
          </figure>
        </div>

        <section className="portal-contact__directions" aria-labelledby="contact-directions">
          <h2 id="contact-directions">Anfahrt und Parken</h2>
          <div className="portal-contact__travel">
            <section aria-labelledby="contact-car">
              <h3 id="contact-car">Anreise mit dem Auto</h3>
              <p>Zentral gelegen und bequem erreichbar. Wir bieten Ihnen exklusive Parkmöglichkeiten direkt im Parkhaus «Stricki».</p>
              <div className="portal-contact__parking">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" focusable="false">
                  <circle cx="12" cy="12" r="10" />
                  <path d="m7 12 3.5 3.5L17 9" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div>
                  <h4>Öffentliches Parkhaus «Stricki»</h4>
                  <p>Der Zugang zur Praxis erfolgt direkt vom Parkhaus aus, 2. OG.</p>
                </div>
              </div>
            </section>
            <section aria-labelledby="contact-transit">
              <h3 id="contact-transit">Öffentlicher Verkehr</h3>
              <p>Dank der optimalen Lage im Stadtzentrum sind wir ideal an das öffentliche Verkehrsnetz angebunden.</p>
              <div className="portal-contact__connection">
                <h4>Bus Linien</h4>
                <p>Bis zur Haltestelle «Bachstrasse» oder «Rhybadi».</p>
              </div>
              <div className="portal-contact__connection">
                <h4>S-Bahn / Hauptbahnhof</h4>
                <p>Vom Bahnhof Schaffhausen sind es nur etwa 8 Minuten entspannter Fussweg.</p>
              </div>
            </section>
          </div>
        </section>
      </div>
    </main>
  );
}
